import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Container, Grid } from "@mantine/core";
import { Link } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import "./location1.css";
import Swal from "sweetalert2";
import { GetEmployeeType, getOrgId } from "../../api";
import {
  HEADERS,
  AddEmployeeType,
  EmployeeTypeNameCheck,
  EditEmployeeType,
  DeleteEmployeeType,
} from "../../api";
import axios from "axios";

export default function AddEmployee1() {
  const [employee_type, setFetchEmpType] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);

  const handleButtonClick = async () => {
    const { value: formValues, isConfirmed } = await Swal.fire({
      title: '<span ">Add Employee Type</span>',
      html: `
      <div class="p-2 d-flex flex-column gap-2">
          <div class="d-flex flex-column">
            <small class="text-start">Employee Type</small>
            <input id="employeetypename" class="form-control mt-1" placeholder="Enter employee type name" autofocus>
          </div>
      </div>
        `,
      showCancelButton: true,
      confirmButtonText: "Add",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-custom-confirm-btn",
        cancelButton: "swal-custom-cancel-btn",
      },
      preConfirm: async () => {
        const employeetypename =
          Swal.getPopup().querySelector("#employeetypename").value;

        if (!employeetypename) {
          Swal.showValidationMessage("Please fill in the fields");
          return { success: false, message: "Please fill in the fields" };
        }
        const orgID = getOrgId();
        const reqBody = {
          organization_id: orgID,
          employee_type_name: employeetypename,
        };

        try {
          const response = await fetch(EmployeeTypeNameCheck, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify(reqBody),
          });

          if (!response.ok) {
            throw new Error("Failed to check employee type existence");
          }
          const data = await response.json();
          if (data.response_code === "0000") {
            const requestBody = {
              organization_id: orgID,
              employee_type_name: employeetypename,
              is_vendor: true,
            };

            const addResponse = await fetch(AddEmployeeType, {
              method: "POST",
              headers: HEADERS,
              body: JSON.stringify(requestBody),
            });

            if (addResponse.ok) {
              window.location.reload();
              const result = await addResponse.json();
              // $&

              return {
                success: result.response_code === "0000",
                message: result.response_description,
              };
            } else {
              console.error("Failed to add employee type");
              return { success: false, message: "Failed to add employee type" };
            }
          } else {
            Swal.showValidationMessage(
              `Employee type ${employeetypename} already exists`
            );
            return { success: false, message: "Employee type already exists" };
          }
        } catch (error) {
          console.error("Error during employee type check:", error);
          return {
            success: false,
            message: "Error during employee type check",
          };
        }
      },
    });

    if (isConfirmed) {
      const { success, message } = formValues;
      Swal.fire(
        success ? "Added!" : "Failed!",
        success
          ? "Employee type has been added."
          : `Failed to add the Employee type. ${message}`,
        success ? "success" : "error"
      );
    }
  };

  const EditEmployeeBtn = async (EmpTypeId) => {
    // $&
    try {
      const emp_type_name = employee_type.find(
        (employee) => employee.employee_type_id === EmpTypeId
      );

      const result = await Swal.fire({
        title: "Edit Employee Type Name",
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
        html: `
          <div class="p-2 d-flex flex-column gap-2">
            <div class="d-flex flex-column">
              <small class="text-start">Employee Type Name</small>
              <input id="edit_emp_type" class="form-control mt-1" value="${
                emp_type_name ? emp_type_name.employee_type_name : ""
              }" autofocus>
            </div>
          </div>
             
          `,
        preConfirm: async () => {
          const update_emp_type =
            Swal.getPopup().querySelector("#edit_emp_type").value;
          if (!update_emp_type) {
            Swal.showValidationMessage("Please enter an employee type name");
            return false;
          }
          const orgID = getOrgId();
          const reqBody = {
            organization_id: orgID,
            employee_type_name: update_emp_type,
          };

          try {
            const response = await fetch(EmployeeTypeNameCheck, {
              method: "POST",
              headers: HEADERS,
              body: JSON.stringify(reqBody),
            });

            if (!response.ok) {
              throw new Error("Failed to check employee type existence");
            }

            const data = await response.json();

            if (
              data.response_code === "0000" ||
              data.employee_type_id === EmpTypeId
            ) {
              // Employee type does not exist or same as the current one being edited, proceed with updating
              return {
                employee_type_name: update_emp_type,
                is_vendor: false,
              };
            } else {
              // Employee type already exists and it's different from the current one being edited, show error message
              Swal.showValidationMessage(
                `Employee type ${update_emp_type} already exists`
              );
              return false;
            }
          } catch (error) {
            console.error("Error during employee type check:", error);
            Swal.fire(
              "Failed!",
              "Error during employee type check. Please try again later.",
              "error"
            );
            return false;
          }
        },
      });

      if (result.isConfirmed) {
        const { employee_type_name, is_vendor } = result.value;

        const requestBody = {
          employee_type_id: EmpTypeId,
          employee_type_name,
          is_vendor,
        };

        // Send the update request to the API
        const response = await axios.post(EditEmployeeType, requestBody, {
          headers: HEADERS,
        });

        if (response.data.response_code === "0000") {
          const updatedEmpType = employee_type.map((employee) =>
            employee.employee_type_id === EmpTypeId
              ? { ...employee, employee_type_name, is_vendor }
              : employee
          );

          setFetchEmpType(updatedEmpType);
          Swal.fire("Updated!", "Employee type has been updated.", "success");
          window.location.reload();
        } else {
          Swal.fire(
            "Failed!",
            "Failed to update the Employee type. Please try again later.",
            "error"
          );
        }
      }
    } catch (error) {
      console.error("Error updating Employee type:", error);
      Swal.fire(
        "Failed!",
        "An error occurred while updating the Employee type.",
        "error"
      );
    }
  };

  const handleDelete = async (empId) => {
    try {
      const confirmDelete = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this employee type!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });

      if (confirmDelete.isConfirmed) {
        const response = await axios.post(
          DeleteEmployeeType,
          { employee_type_id: empId },
          { headers: HEADERS }
        );

        if (response.data.response_code === "0000") {
          Swal.fire("Deleted!", "Employee Type has been deleted.", "success");
          window.location.reload();
        } else {
          Swal.fire(
            "Failed!",
            "Failed to delete the Employee Type. Please try again later.",
            "error"
          );
          console.error(
            "Error deleting employee type. Please try again later."
          );
        }
      }
    } catch (error) {
      console.error("An error occurred while deleting employee type:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();

      try {
        const requestData = { org_id: OrgID };
        const response = await axios.post(GetEmployeeType, requestData, {
          headers: HEADERS,
        });

        if (response.data.response_code === "0000") {
          setFetchEmpType(response.data.data);
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const tableData = employee_type.map((employee) => ({
    id: employee.employee_type_id,
    employee_type_name: employee.employee_type_name,
    edit: (
      <Link onClick={() => EditEmployeeBtn(employee.employee_type_id)}>
        <FontAwesomeIcon icon={faEdit} style={{ cursor: "pointer" }} />
      </Link>
    ),
    delete: (
      <FontAwesomeIcon
        icon={faTrash}
        style={{ cursor: "pointer" }}
        onClick={() => handleDelete(employee.employee_type_id)}
      />
    ),
  }));

  const tableColumns = [
    { accessorKey: "employee_type_name", header: "Employee" },
    { accessorKey: "edit", header: "Edit" },
    { accessorKey: "delete", header: "Delete" },
  ];

  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  return (
    <div fluid>
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link
            className="previou-link text-decoration-none"
            to="/user-setting-dashboard"
          >
            Setting
          </Link>
          <span>/</span>
          <span className="current-link text-decoration-none">
            Employee Type
          </span>
        </span>
      </div>
      <div className="headerSection">
        <span className="title">Employee Type</span>
      </div>
      <div className="d-flex">
        <button
          className="ms-auto button add-button"
          onClick={handleButtonClick}
        >
          Add Employee Type
        </button>
      </div>
      <div className="tab mt-3">
        <MantineReactTable
          columns={tableColumns}
          data={paginatedData}
          enablePagination={false}
          enableColumnFilters={true}
          enableSorting={true}
          enableColumnOrdering={true}
          enableGlobalFilter={true}
          enableFullScreenToggle={false}
          enableRowSelection={false}
          mantineTableBodyCellProps={{
            style: {
              backgroundColor: "#C8E3EC60",
              color: "#505050",
              border: "0.5px solid #fff",
              padding: "10px",
            },
          }}
          mantineTableHeadCellProps={{
            style: {
              backgroundColor: "#2d7d9f",
              fontSize: "14px",
              fontWeight: 500,
              color: "#fff",
              border: "1px solid #fff",
            },
          }}
          mantineTableBodyRowProps={(row) => ({
            style: {
              backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
            },
          })}
        />
        <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: "14px" }}>Items per page:</span>
            <select
              className="form-select"
              style={{ width: "110px" }}
              value={pageSize}
              onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
            </select>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <span style={{ fontSize: "14px" }}>
              {totalRows === 0
                ? "Showing 0 to 0 of 0 entries"
                : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <button
              className="previous-button"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 0}
            >
              Previous
            </button>
            <button
              className="add-button text-center justify-content-center"
              style={{ width: "100px" }}
              onClick={() => handlePageChange(page + 1)}
              disabled={(page + 1) * pageSize >= tableData.length}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
